import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        pointerEvents: "none",
        position: "absolute",
        start: 0
    }
});
export default stylesheet;
